import { getRequest } from '@/core';
import { unknownItems } from '@/requests';

export default async function getUnknownItemsRequest() {
	let url = unknownItems.getPath();
	return getRequest(url);
}